import styles from './styles';

export default (tabValue: string, value: string) => {
  if (tabValue === value) {
    return styles.selectedTab;
  }

  return styles.tab;
};
